import { Popover } from '@mui/material';
import React, { ReactNode } from 'react';

type PopoverProps = {
  open: boolean;
  anchorEl: any;
  onClose: () => void;
  children: ReactNode;
};

const EdPopover: React.FC<PopoverProps> = (props) => {
  const { children, ...other } = props;

  return (
    <Popover
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      {...other}
    >
      {children}
    </Popover>
  );
};

export default EdPopover;
